import Tabla from './Tabla'

export default Tabla